import { useEffect, useState } from 'react';
import { useIoContext } from '~/contexts';
import { advancedTo, isEnteringAt, shownAmountOf, stillMotion, swappedTo } from './useOpportunityDeckMotion.utils';
const FRAME_MS = 16;
export const useOpportunityDeckMotion = (card)=>{
    var _ref;
    var _motion_leaving;
    const { browser, getNow } = useIoContext();
    const [motion, setMotion] = useState(()=>stillMotion(card, getNow().getTime()));
    if (motion.identity !== card.identity) {
        const nowMs = getNow().getTime();
        setMotion(browser.prefersReducedMotion() ? stillMotion(card, nowMs) : swappedTo(motion, card, nowMs));
    }
    useEffect(()=>{
        if (motion.startedAtMs != null) {
            return browser.schedule(FRAME_MS, ()=>setMotion((current)=>advancedTo(current, getNow().getTime())));
        }
    }, [
        motion.startedAtMs,
        motion.nowMs,
        motion.identity
    ]);
    return {
        shownCard: (_ref = (_motion_leaving = motion.leaving) === null || _motion_leaving === void 0 ? void 0 : _motion_leaving.card) !== null && _ref !== void 0 ? _ref : card,
        shownAmount: shownAmountOf(motion),
        isLeaving: motion.leaving != null,
        isEntering: isEnteringAt(motion)
    };
};
